import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "h-full w-full flex-center flex-col"
};
const _hoisted_2 = {
  class: "text-3xl"
};
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingLayout',
  props: {
    hideLoader: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_NSpin = _resolveComponent("NSpin");
      return _openBlock(), _createBlock(DefaultInGameLayout, _mergeProps(_ctx.$attrs, {
        "hide-footer": "",
        onClickCapture: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop", "prevent"]))
      }), {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [!__props.hideLoader ? (_openBlock(), _createBlock(_component_NSpin, {
          key: 0,
          size: "large",
          class: "mb-8"
        })) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", {}, () => [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('processing...')), 1)])])]),
        _: 3
      }, 16);
    };
  }
});